import GlobalChartsPage from './global-charts.page.vue'

let routes = [
  {
    path: '/global-charts',
    name: 'global-charts',
    component: GlobalChartsPage
  },
]

export default routes
